import { render, staticRenderFns } from "./generalValue.vue?vue&type=template&id=4190d9ac&scoped=true"
import script from "./generalValue.vue?vue&type=script&lang=js"
export * from "./generalValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4190d9ac",
  null
  
)

export default component.exports